<template>
    <div class="flex flex-wrap mb-2">
        <div class="font-bold w-full mt-2 mb-1 border-b">Levels (%)</div>
        <div class="w-full p-0 factor-levels">
            <div class="form-check form-check-inline mr-0" v-for="(factor, factorIndex) in factors" :key="factorIndex">
                <input @change="updateFactors" type="checkbox" v-model="factor.enabled" name="">
                <input :disabled="!factor.enabled" class="form-input form-input-sm" @change="updateFactors" type="text" name="" v-model="factor.value">
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    defaultValue: Array
});

const emit = defineEmits(['update:modelValue']);

const factors = ref(getFactors(props.defaultValue));

function getFactors(defaultValues) {
    return defaultValues.map(factor => ({
        enabled: factor.shown,
        value: (factor.value * 100).toFixed(2)
    }));
}

function updateFactors() {
    const updatedFactors = factors.value.map(factor => ({
        shown: factor.enabled,
        value: parseFloat(factor.value) / 100
    }));

    emit('update:modelValue', updatedFactors);
}

watch(() => props.defaultValue, () => {
    factors.value = getFactors(props.defaultValue);
    updateFactors();
});
</script>

<style lang="scss">
.factor-levels {
    column-count: 3;
}
</style>
